import { motion } from "framer-motion";
import familyCabana from "@/assets/family-cabana.jpg";
import familyFloating from "@/assets/family-floating.jpg";
import kayaking from "@/assets/kayaking.jpg";
import hammockRelaxing from "@/assets/hammock-relaxing.jpg";
import islandAerial from "@/assets/island-aerial.jpg";
import cabanaInterior from "@/assets/cabana-interior.jpg";
import cabanasWaterView from "@/assets/cabanas-water-view.jpg";
import cabanaDockView from "@/assets/cabana-dock-view.jpg";
import cabanaHammock from "@/assets/cabana-hammock.jpg";
import familyFunDadKids from "@/assets/family-fun-dad-kids.jpg";
import cabanaFloatingMat from "@/assets/cabana-floating-mat.jpg";
import paddleboardingSwimming from "@/assets/paddleboarding-swimming.jpg";
import groupKidsCabana from "@/assets/group-kids-cabana.jpg";
import beachVolleyball from "@/assets/beach-volleyball.png";
import bbqGrilling from "@/assets/bbq-grilling.jpg";
import coupleFloating from "@/assets/couple-floating.jpg";

const images = [
  { src: islandAerial, alt: "Aerial view of Son's Island" },
  { src: familyCabana, alt: "Family enjoying lakeside cabana at Son's Island" },
  { src: cabanaFloatingMat, alt: "Cabana with floating mat on the lake" },
  { src: familyFloating, alt: "Family fun on floating mat at Son's Island" },
  { src: kayaking, alt: "Mother and son kayaking at Son's Island" },
  { src: beachVolleyball, alt: "Beach volleyball game with cabanas" },
  { src: hammockRelaxing, alt: "Relaxing in a hammock overlooking the lake" },
  { src: bbqGrilling, alt: "BBQ grilling at the cabana" },
  { src: cabanaInterior, alt: "Cabana interior with seating and lake view" },
  { src: groupKidsCabana, alt: "Large group of kids having fun" },
  { src: paddleboardingSwimming, alt: "Paddleboarding and swimming activities" },
  { src: coupleFloating, alt: "Couple relaxing on floating mat" },
];

const PhotoGallery = () => {
  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Why Families & Friends Keep Coming Back
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Moments of joy, relaxation, and togetherness on our private island.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 lg:gap-6">
          {images.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`relative overflow-hidden rounded-2xl group ${
                index === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
                decoding="async"
                className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                  index === 0 ? "h-64 md:h-full" : "h-48 lg:h-64"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhotoGallery;
